import { styled } from "@mui/material";

import { KeyValueContent } from "./key-value-content";
import { KeyValueLabel } from "./key-value-label";

export const Label = styled(KeyValueLabel)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

export const Content = styled(KeyValueContent)({});
